import React, {Component} from 'react'
import "react-toggle/style.css"
import {Link} from 'react-router-dom'
import {FormattedMessage} from 'react-intl'
import Icon from "../common/icon/icon.component.jsx";


class IntegrationCard extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            enabled: this.props.enableLinkDefaultChecked,
            toggleDisabled: this.props.toggleDisabled || false,
            authConnect: this.props.authConnect
        }

    }

    render() {
        let category = ''
        switch (this.props.category) {
            case 'accounting':
                category = <div className="card-footer text-muted">
                    <Icon value={"calculator"} /> <FormattedMessage
                    id="integration.listing.category.accounting"
                    defaultMessage="Accounting"
                    />
                </div>
                break;
            case 'productivity':
                category = <div className="card-footer text-muted">
                    <Icon value={"chart-line"}/> <FormattedMessage
                        id="integration.listing.category.productivity"
                        defaultMessage="Productivity"
                    />
                </div>
                break;
            case 'payment':
                category = <div className="card-footer text-muted">
                    <Icon value={"credit-card"}/> <FormattedMessage
                        id="integration.listing.category.payment"
                        defaultMessage="Online payment"
                    />
                </div>
                break;
            case 'supplier':
                category = <div className="card-footer text-muted">
                    <Icon value={"dolly"}/> <FormattedMessage
                    id="integration.listing.category.supplier"
                    defaultMessage="Supplier"
                />
                </div>
                break
            case 'pos':
                category = <div className="card-footer text-muted">
                    <Icon value={"shopping-cart"}/> <FormattedMessage
                    id="integration.listing.category.pos"
                    defaultMessage="POS Software"
                />
                </div>
                break;
            case 'analytics':
                category = <div className="card-footer text-muted">
                    <Icon value={"analytics"}/> <FormattedMessage
                    id="integration.listing.category.analytics"
                    defaultMessage="Analytics"
                />
                </div>
                break;
        }

        var cardImageStyle = {
            maxHeight: 100 + "px",
            objectFit: "contain",
        };
        const imgClassName = this.props.imgClassName ? this.props.imgClassName : "pl-2 pt-2"
        return (
            <div className="card mb-3 w-100 px-0">
                <img className={"img-fluid w-50 center-block " + imgClassName} style={cardImageStyle} src={this.props.imgPath}/>

                <div className="card-body">
                    <h5 className="card-title">{this.props.title}</h5>
                    <p className="card-text">
                        {this.props.description}
                    </p>
                    <div className="card-text text-right">
                        <Link to={"/integrations/new/" + this.props.integrationKey} className="btn btn-primary">
                            <FormattedMessage
                                id="integration.listing.add_integration_link"
                                defaultMessage="Add integration"
                            />
                        </Link>
                    </div>

                </div>
                {category}
            </div>
        );
    }
}

export default IntegrationCard


// WEBPACK FOOTER //
// ./src/integration/integrationcard.component.jsx